import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Props {
  className?: string;
  label?: string;
  center?: boolean;
}

export function LoadingSpinner({ className, label, center }: Props) {
  const content = (
    <span className="inline-flex items-center gap-2 text-sm text-muted-foreground">
      <Loader2 className={cn('h-4 w-4 animate-spin', className)} />
      {label ? <span>{label}</span> : null}
    </span>
  );
  if (center) return <div className="flex h-full w-full items-center justify-center py-12">{content}</div>;
  return content;
}
